import { render, staticRenderFns } from "./field.vue?vue&type=template&id=3dc45d8c"
import script from "./field.vue?vue&type=script&lang=ts"
export * from "./field.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports